// extracted by mini-css-extract-plugin
module.exports = {"type":"type_type__2K55o","size--small":"type_size--small__1ArBV","size--xs":"type_size--xs__3zwzQ"};